var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.757 4.022A2.658 2.658 0 004.099 6.68v9.988a2.658 2.658 0 002.658 2.658h9.988a2.658 2.658 0 002.658-2.658V6.68a2.658 2.658 0 00-2.658-2.658H6.757zm10.485 3.35a.95.95 0 11-1.9 0 .95.95 0 011.9 0zm-1.646 4.526a3.845 3.845 0 11-7.69 0 3.845 3.845 0 017.69 0z","fill":"#727183"}));
}

Instagram.defaultProps = {"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none"};

module.exports = Instagram;

Instagram.default = Instagram;
